import React from 'react';
import SvgIcon, { SvgIconProps } from './SvgIcon';

const DeleteIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props}>
            <React.Fragment>
                <path d="M8 9h8v10H8z" opacity=".3" />
                <path d="M15.5 4l-1-1h-5l-1 1H5v2h14V4zM6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9z" />
            </React.Fragment>
        </SvgIcon>
    );
};

export default DeleteIcon;
